import cpe from "./modules/cpe";

export default { cpe };
